//////////////////////////////////////////////
//! Portfoli Map
//////////////////////////////////////////////

/* :::::::::::::::::::::::::::::::::::::::::::
	# VIEW $ARGS

	el = '' 				/ DOM id for map
	queries = {} 		/ Current queries object from app
	dispatcher = {}		/ app.dispatcher object
::::::::::::::::::::::::::::::::::::::::::: */

/* :::::::::::::::::::::::::::::::::::::::::::
	# VIEW GUIDE

	## Init
	1. Make the Map object
	2. Load Pins
	3. Add pins to Map

::::::::::::::::::::::::::::::::::::::::::: */

portfolioMap = function (el, queries, dispatcher) {

	//::::::::::::::::::::::::::::::::::::::::::::
	//! STATIC VARS
	//::::::::::::::::::::::::::::::::::::::::::::

	this.el = el;
	this.siteUrl = $(DOM.data).data('wpsiteurl');
	this.themeUrl = $(DOM.data).data('wpthemeurl');
	this.markerIco = $(DOM.data).data('wpthemeurl') + '/img/MapMarker-mini.svg';
	this.clusterIco = $(DOM.data).data('wpthemeurl') + '/img/m';

	this.settings = {
		zoom: parseInt($(el).attr('data-mapZoom')),
		//maxZoom 				: 15,
		center: {
			lat: 51,
			lng: 0
		},
		mapTypeId: google.maps.MapTypeId[$(el).attr('data-mapType')],
		mapTypeControl: false,
		fullscreenControl: false,
		streetViewControl: false,
		visualRefresh: true,
		gestureHandling: 'cooperative',
		clickableIcons: false, // prevent transport icons form being clickable
		styles: snazzyMap, // see `js/_vendor/snazzyMapStyle.js` for style

	};


	//::::::::::::::::::::::::::::::::::::::::::::
	//! DYNAMIC VARS
	//::::::::::::::::::::::::::::::::::::::::::::

	this.map = ''; // MAP OBJECT
	this.markers = ''; // MARKERS LAYER
	this.clusters = ''; // CLUSTERS LAYER

	this.queries = queries;
	this.currentLocation = '';
	this.queriedMarkers = [];

	//////////////////////////////////////////////
	this.init();
	//////////////////////////////////////////////
};

portfolioMap.prototype = {

	constructor: portfolioMap,

	//////////////////////////////////////////////
	//! INITIALIZER
	//////////////////////////////////////////////
	init: function () { //console.log('## INIT MAP');

		// Remove dom tag for location
		$(DOM.filtersBar.tags + ' span[data-tax="location_prime"]').remove();

		// 1. MAKE THE MAP
		this.makeMap(this.el);
		this.spinner(true); // show spinner

		this.bindEvents();
	},

	//////////////////////////////////////////////
	//! EVENT HANDLERS
	//////////////////////////////////////////////
	bindEvents: function () {

		// When posts loaded...
		app.dispatcher.addEventListener(EVENTS.API.LOAD + '_portfolio', this.addMarkers.bindX(this));


		// If posts fail to laod
		app.dispatcher.addEventListener(EVENTS.API.FAILED, function (e) {
			alert('API FIALED');
		}.bindX(this));


		app.dispatcher.addEventListener(EVENTS.FILTERS.CHANGE, this.filterChange.bindX(this));


		// CLICK EVENTS
		// Location selection
		$('input:checkbox[name=' + DOM.filtersBar.location_prime_group + ']').change(function (e) {

			var $this = e.target;

			$('input:checkbox[name=' + DOM.filtersBar.location_prime_group + ']').prop('checked', false);
			$($this).prop('checked', true);

			app.dispatcher.dispatch(EVENTS.MAP.NEWLOCATION);

			//console.log($this);
			var loc = this.mapLocation($this.value); // get pins for the location (even if not currently visible)
			this.locateMarkers(loc); // move the map

		}.bindX(this));

		app.dispatcher.addEventListener(EVENTS.FILTERS.CLEAR, this.mapLocationReset.bindX(this));

		$(DOM.filtersBar.mapFind + '-1 , ' + DOM.filtersBar.mapFind + '-2').click(function () {
			// console.log(this.queriedMarkers);

			/*
						if (this.queriedMarkers.length > 0) {
							this.locateMarkers(this.queriedMarkers);
						} else {
							this.locateMarkers(this.markers);
						}
			*/
			app.modalCLose();

		}.bindX(this));

	},

	//////////////////////////////////////////////
	//! TAXONOMY FILTERS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! filterChange
	//::::::::::::::::::::::::::::::::::::::::::::
	filterChange: function (e, d) {



		//$(DOM.filtersBar.mdl).addClass('is-loading');


		//console.log('## MAP FILETRS CHANGED');
		//console.log(this.queries);
		//console.log(d);

		var currentService = parseInt(d.service[0]);
		var currentSector = parseInt(d.sector[0]);

		this.queriedMarkers = []; // rest queried markers

		for (i = 0; i < this.markers.length; i++) {

			// Get the Term values for this pin
			var servIDs = this.markers[i].service;
			var sectIDs = this.markers[i].sector;

			if (
				// 3.a Check Services
				((jQuery.inArray(currentService, servIDs) !== -1) || (currentService === -1)) &&
				// 3.b Check Sectors
				((jQuery.inArray(currentSector, sectIDs) !== -1) || (currentSector === -1))
			) {

				//console.log('PIN '+ i + ' TRUE');

				// 4. Show the pin
				this.markers[i].setVisible(true); // show it
				this.queriedMarkers.push(this.markers[i]); // store

			} else {

				//console.log('PIN '+ i + ' FALSE');

				// 4. Hide the pin
				this.markers[i].setVisible(false);
			}

			this.markerCluster.repaint(); // redraw clusters
		}


		this.checkLocationUrl();

	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! CHECK A MARKERS AGAINST A TERM
	//::::::::::::::::::::::::::::::::::::::::::::
	checkTax: function (taxName, terms) {

		// Get the query list for tax
		tax = this.queries[taxName];

		// Default show post
		var result = true;

		// for every entry in the query..
		for (i = 0; i < tax.length; i++) {

			// if this query is not in
			if (jQuery.inArray(tax[i], terms) === -1) {
				result = false;

				// If query exists then add it back in
			} else {
				result = true;
			}
		}

		return result;
	},


	//////////////////////////////////////////////
	//! MAP BUILDERS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! MAKE THE MAP OBJECT
	//::::::::::::::::::::::::::::::::::::::::::::
	makeMap: function (el) { //console.log('## MAKING MAP');

		var $el = $(el);
		this.map = new google.maps.Map($el[0], this.settings);

		// Listerner for fitbounds calls
		google.maps.event.addListener(this.map, 'zoom_changed', function () {

			// console.log('MAP ZOOM DETECTED TO: ' + this.getZoom());

		});

		this.map.initialZoom = true;

	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! ADD PINS TO THE MAP
	//::::::::::::::::::::::::::::::::::::::::::::
	addMarkers: function (e, d) { //console.log('## ADD MARKER');
		var list = d; // get data on posts
		var icon = this.markerIco;
		var map = this.map;

		var queriedMarkers = []; // store markers that match the defaulkt query

		//console.log(list);

		/*
				// remove itesm with no map co-ords
				for (i=0; i < list.length; i++){
					if (list[i].acf == null) {

						list.splice($.inArray(list[i], list),1);
					}
				}
		*/



		this.markers = list.map(function (location, i) {



			if (location.acf) {

				var marker = new google.maps.Marker({
					map: map,
					position: {
						lat: Number(location.acf.coordinates.lat),
						lng: Number(location.acf.coordinates.lng)
					},
					label: '',
					id: location.id,
					icon: icon,
					// Add taxonomies to markers
					location_prime: location.location_prime,
					sector: location.sector,
					service: location.service,
				});

				// check Sector and Service taxonomies for marker terms..

				// Check for Services
				if (this.queries.sector[0] !== -1) {
					//console.log('There is a sector query for '+ this.queries.sector.toString());
					var check = this.checkTax('sector', marker.sector);

					//console.log(marker.id + ' ' + check);

					if (check === false) {
						marker.setVisible(false);
					}

				}


				if (this.queries.service[0] !== -1) {
					//console.log('There is a sector query for '+ this.queries.sector.toString());

					var check = this.checkTax('service', marker.service);

					//console.log(marker.id + ' ' + check);

					if (check === false) {
						marker.setVisible(false);

					}

				}

				if (marker.visible) {
					this.queriedMarkers.push(marker); // push markers that are visible to current list
				}

				this.spinner(false); // hide spinner

				// Add ma
				marker.setAnimation(google.maps.Animation.DROP);

				// If the marker is filtered in add it to queried list and animate it in
				/*
							if (marker.visible === true) {

								queriedMarkers.push(marker);

							} else {
								//console.log('excluding post:' + marker.id);
							}
				*/

				// ADD CLICK LISTENER FOR MARKER
				marker.addListener('click', function () {
					this.onMarkerClick(location.id);
				}.bindX(this));

				return marker;
			}



		}.bindX(this));

		// RUN AFTER ALL MARKERS ADDED
		this.initCluster();

		// If there is a location querired
		if (this.queries.location_prime[0] !== -1) {

			//console.log('LOCATION: ' + this.queries.location_prime[0])
			var queriedLoc = this.mapLocation(this.queries.location_prime[0]);
			this.locateMarkers(queriedLoc);

		} else {

			//alert();
			//alert(this.queriedMarkers.length)

			if (this.queriedMarkers.length > 0) {
				this.locateMarkers(this.queriedMarkers);
			} else {

				//alert();
				app.dispatcher.dispatch(EVENTS.MAP.RESET);
				this.locateMarkers(this.markers);
			}

		}

		// this.tidyUrl();

	},


	//////////////////////////////////////////////
	//! MAP MANIPULATION
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! LOCATE MAP TO A SET OF MARKERS
	//::::::::::::::::::::::::::::::::::::::::::::
	locateMarkers: function (markers) { //console.log(markers);

		var bounds = new google.maps.LatLngBounds();

		for (var i = 0; i < markers.length; i++) {

			bounds.extend(markers[i].getPosition());
			//console.log(this.markers[ i ]);
		}

		this.map.fitBounds(bounds);
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! MAP LOCATION - get the markers for a given location term
	//::::::::::::::::::::::::::::::::::::::::::::
	mapLocation: function (locationID) {

		locationID = parseInt(locationID);

		var validPins = [];

		if (locationID == -1) {
			//console.log('LOCATING ALL PINS');

			validPins = this.markers;

		} else {
			// console.log('LOCATING: ' + locationID);




			//console.log(this.markers.length);

			for (i = 0; i < this.markers.length; i++) {

				//console.log(this.markers[i]['location_prime']);

				var pinLocs = this.markers[i].location_prime;

				//console.log(locationID);
				//console.log(pinLocs);
				//console.log(jQuery.inArray(locationID, pinLocs));

				if (jQuery.inArray(locationID, pinLocs) !== -1) {

					validPins.push(this.markers[i]);

					// console.log('validPins');

				}

			}





			//console.log('VALID PINS:');
			//console.log(validPins)




		}

		this.queries.location_prime[0] = locationID;

		//this.checkLocationUrl();

		return validPins;

	},

	mapLocationReset: function (e) {
		this.mapLocation(-1);
	},

	checkLocationUrl: function () {
		//console.log('## CHECKING FOR LOCATION URL: '+ this.queries.location_prime[0]);

		var url = window.location.href;
		var queryRoot = new RegExp('\\?');
		var locQuery = new RegExp('location_prime=[\\w|-]*&?');
		var locSlug = '';

		var pushUrl = function (url) {
			history.pushState(null, "", url);
			//console.log('FINAL URL = ' +url);
		};


		// 1a. The new location is -1 (all)..
		if (this.queries.location_prime[0] == -1) {

			//console.log('## NO LOACTION QUERY DETECTED');

			//console.log(locSlug);


			url = url.replace(locQuery, locSlug); // remove any location query from the url

			pushUrl(url);
		}

		// 1b. There is a valid location selected..
		else {

			//console.log('## NEW LOACTION QUERY DETECTED in ' + url);

			// 2 Get the data for the new location
			var q = app.wp.siteUrl + '/wp-json/wp/v2/location_prime/' + this.queries.location_prime[0] + '?&fields=slug';
			app.loadJSON(q, function (response) {

				// 3. Update with the new slug
				locSlug = JSON.parse(response);
				locSlug = 'location_prime=' + locSlug.slug + '&';
				//console.log('## LOCATION TO ADD = ' + locSlug);

				// 4a. There IS a query attached to the addressbar..
				if (queryRoot.test(url)) {
					//console.log('## EXISTING QUERY DETECTED');

					// 5a. There is currently a location query in the URL...
					if (locQuery.test(url)) {
						//console.log('## EXISTING LOCATION QUERY DETECTED');
						url = url.replace(locQuery, locSlug);

						// 5b There ISNT a location query int he URL..
					} else {
						// console.log('## ADDING NEW LOCATION QUERY');
						// console.log(url);
						url = url.replace(queryRoot, '?' + locSlug);

					}

					// 4b. There is NO query attached to the current URL..
				} else {
					//console.log('## NO QUERY ATTACHED TO URL, ADDING');
					//console.log(url + ' + ' + '?' + ' + ' + locSlug);

					url = url + '?' + locSlug;

				}

				pushUrl(url);
			});

		}
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! CREATE CLUSTERS
	//::::::::::::::::::::::::::::::::::::::::::::
	initCluster: function () {

		this.markerCluster = new MarkerClusterer(this.map, this.markers, {
			ignoreHiddenMarkers: true,
			imagePath: this.clusterIco,
		});

	},

	//////////////////////////////////////////////
	//! MODAL WINDOW FUNCTIONS
	//////////////////////////////////////////////
	onMarkerClick: function (id) {

		//alert(id);

		var url = this.siteUrl + '/wp-json/wp/v2/projects/' + id;

		app.loadJSON(url, function (response) {


			var proj = JSON.parse(response);

			this.markerContent(proj);

		}.bindX(this));

	},

	markerContent: function (proj) {

		var makeTaxList = function (taxName) {

			var terms = [];

			$.grep(proj.acf[taxName], function (a, i) {
				terms.push(a.name);
			});

			var list = '';
			for (i = 0; i < terms.length; i++) {

				var term = terms[i].replace(/\s/g, '&nbsp;');

				list = list + '<span>' + term + '</span>';

				if (i < terms.length - 1) {
					list = list + '<span class="utl-hidden-mob"> •&nbsp;</span>';
				}
			}
			return list;
		};



		var services = makeTaxList('service');
		var sectors = makeTaxList('sector');


		var featuredimage = '';

		if (proj.acf['featured-image']) {
			featuredimage = '<img class="mdl-project__img" src="' + proj.acf['featured-image'].sizes.sm + '" alt="" />';
		}

		var cta = '';
		if (proj.content.rendered.length > 0) {
			cta =

				'<a class="btn btn-cta" href="' + proj.link + '" target="_self" style="color:' + app.page.currentColor + ';">' +
				'<span class="btn-cta__text">Read more</span>' +
				'<span class="btn-cta__icon"><svg class="ico ico-next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle class="ico__bkg" cx="25" cy="25" r="22.5"/><polygon class="ico__glyph" points="23.41 33.41 20.59 30.59 26.67 24.5 20.59 18.41 23.41 15.59 32.33 24.5 23.41 33.41"/><path class="ico__round" d="M25,2A23,23,0,1,0,48,25,23,23,0,0,0,25,2ZM23.41,33.41l-2.82-2.82,6.08-6.09-6.08-6.09,2.82-2.82,8.92,8.91Z"/></svg></span>' +
				'</a>';
		}


		var modalContent =

			'<div id="mdl-project-' + proj.id + '" class="mdl-project">' +

			featuredimage +
			'<span class="mdl-project__services">' + services + '</span>' +
			'<span class="mdl-project__sectors">' + sectors + '</span>' +
			'<div class="mdl-project__heading">' +
			'<h3 class="mdl-project__title">' + proj.title.rendered + '</h3>' +
			'<span class="mdl-project__location">' + proj.acf.address + '</span>' +
			'</div>' +
			proj.acf.excerpt +
			cta +
			'</div>';

		app.modalOpen($('#js-map-portfolio'), modalContent);
	},

	//////////////////////////////////////////////
	//! MISC FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! TIDY UP URL (REMOVE ?QUERYIES)
	//::::::::::::::::::::::::::::::::::::::::::::
	/*
		tidyUrl:function(){
			//alert('TIDY URL');
			var url = window.location.href;

			var re = new RegExp('\\?.*', 'i');;
			url = url.replace(re, '');

			history.pushState(null, "", url);

		},
	*/

	//::::::::::::::::::::::::::::::::::::::::::::
	//! SPINNER ( Show/Hide spinner )
	//::::::::::::::::::::::::::::::::::::::::::::

	spinner: function (show) {

		if (show) {
			$(DOM.maps.loader).animate({
				opacity: 1,
			}, 500);
		} else {
			$(DOM.maps.loader).animate({
				opacity: 0,
			}, 500);
		}

	}

};